import React from "react";
import { StyleSheet, TouchableOpacity, View } from "react-native";

import Img from "components/img";
import Text from "components/Text";
import { colors, sizes } from "assets/constants";
import Icon from "./Icon";
import css from "styles";
import { _goToCorp } from "routers/helper";
import { useDeleteCorp, useLoginToCtoAccount } from "clients/apis";
import ConfirmAlert from "./ConfirmAlert";
import { useFlag } from "hooks";
import { Button, DeleteAlertComponent, LoadingBox } from "components";
import tinycolor from "tinycolor2";

const CorpCard: React.FC<{ corp: CorpT; refetchCorps: () => void }> = ({
  corp,
  refetchCorps,
}) => {
  const _goToDetails = () => _goToCorp({ corp });

  const { flg: remove, on: goToRemove, off: closeRemove } = useFlag();

  const deleteCorpMut = useDeleteCorp();

  const loginToCtoAccount = useLoginToCtoAccount();
  const _goToThisAccount = () => {
    loginToCtoAccount.mutate({ id: corp?.staff?.[0]?.id });
  };

  const _onDeleteConfirm = (close: () => void) => {
    close();
    deleteCorpMut.mutate({ id: corp?.id }, { onSuccess: refetchCorps });
  };

  return (
    <>
      <TouchableOpacity activeOpacity={0.8} onPress={_goToDetails}>
        <View style={styles.box}>
          <View style={styles.avatar}>
            <View style={styles.avatarPlaceholder}>
              <View style={{ position: "absolute" }}>
                <Icon
                  size={45}
                  name={"rhombus-split"}
                  type="materialCommunity"
                />
              </View>
              <Img
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: sizes.radius.lg + 2,
                }}
                source={{ uri: corp.avatar }}
              />
            </View>
            <Img source={{ uri: corp.avatar }} />
          </View>
          <Text weight="bold"> {corp.name} </Text>

          <View style={{ flex: 1 }} />

          {/* <Button
            style={{ marginHorizontal: sizes.space }}
            onPress={_goToThisAccount}
            square={50}
            bgColor={tinycolor(colors.blue).lighten(50).toString()}
            icon={{
              type: "antDesign",
              name: "login",
              color: colors.blue,
              size: 25,
            }}
          /> */}

          <Button
            style={{ marginHorizontal: sizes.space }}
            onPress={goToRemove}
            square={50}
            bgColor={tinycolor(colors.danger).lighten(40).toString()}
            icon={{
              type: "simpleLine",
              name: "trash",
              color: colors.danger,
              size: 25,
            }}
          />
        </View>
      </TouchableOpacity>

      <ConfirmAlert
        force
        show={remove}
        hide={closeRemove}
        renderContent={(close) => (
          <DeleteAlertComponent
            title={`آیا میخواهید شرکت ${corp?.name} را حذف کنید؟ `}
            remove={() => _onDeleteConfirm(close)}
            cancel={close}
          />
        )}
      />

      {deleteCorpMut.isLoading && <LoadingBox />}

      {loginToCtoAccount.isLoading && <LoadingBox />}
    </>
  );
};

export default CorpCard;

const styles = StyleSheet.create({
  box: {
    ...css.shadow(8),
    flexDirection: "row-reverse",
    borderRadius: sizes.radius.xl,
    backgroundColor: colors.itemsBg,
    alignItems: "center",
    justifyContent: "space-between",
    overflow: "hidden",
    padding: 2,
  },

  avatar: {
    width: 100,
    height: 100,
    backgroundColor: colors.dark._13,
    borderWidth: 1,
    borderColor: colors.white,
    borderRadius: sizes.radius.lg + 2,
  },

  avatarPlaceholder: {
    position: "absolute",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
});
